import React from "react";
import styled, { keyframes } from "styled-components";

const Loading = () => {
  return (
    <Main>
      <Spinner />
    </Main>
  );
};

export default Loading;

const Main = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 100px 1.5rem 200px;
  box-sizing: border-box;
  background: var(--bg-app);
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid #e0eafc;
  border-top: 6px solid #1e90ff;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
